var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { TableCell, TableRow, TableHead, Grid, debounce } from "@mui/material";
const TrialTableHeaderRow = ({ handleColumnClick, sortConfig, trialID, categoryId, checkedDataTypeIds, results, }) => {
    //columns state
    const [columns, setColumns] = useState([]);
    const [sortedColumns, setSortedColumns] = useState([]);
    //================================================================================================
    //                                      useEffect Function
    // Getting the new ResultTableRow from the api and setting the state
    //================================================================================================
    useEffect(() => {
        const getTableResults = () => __awaiter(void 0, void 0, void 0, function* () {
            // let result = await Ptn.ResultTableRow.GetTrialResults(
            //   trialID,
            //   categoryId
            // );
            let result = results;
            // if the checkedDataTypeIds is empty then don't filter the result
            if (checkedDataTypeIds.length > 0) {
                result = result.filter((item) => checkedDataTypeIds.includes(item.dataResultTypeId));
            }
            //distinct columns based on ColumnID
            const cols = result
                .map((item) => ({
                columnId: item.columnID,
                columnName: item.columnName,
                displayName: item.columnName.replace(/([a-z])([A-Z])/g, "$1 $2"),
                originalDisplayIndex: item.columnDisplayIndex,
                sortedDisplayIndex: 0,
                dataResultUnit: item.dataResultUnit,
            }))
                .filter((value, index, self) => index ===
                self.findIndex((t) => t.columnId === value.columnId &&
                    t.columnName === value.columnName))
                .sort((a, b) => a.columnName.localeCompare(b.columnName));
            // add variety name to the first column and re-map the display index
            cols.unshift({
                columnId: "varietyName",
                columnName: "varietyName",
                displayName: "Variety Name",
                originalDisplayIndex: 0,
                sortedDisplayIndex: 0,
                dataResultUnit: "",
            });
            cols.map((column, index) => {
                column.originalDisplayIndex = index;
                return column;
            });
            cols.map((column, index) => {
                if (column.columnName === "total Seasonal" ||
                    // or contains "TotalInc" or contains "TotalExc"
                    column.columnName.includes("totalInc") ||
                    column.columnName.includes("totalExc")) {
                    column.originalDisplayIndex = 20000;
                }
                return column;
            });
            setColumns(cols);
        });
        // getTableResults();
        const handle = debounce(getTableResults, 1000);
        handle();
        return () => handle.clear();
    }, [trialID, categoryId, checkedDataTypeIds, results]);
    //sort the columns based on the SelectedColumnIndex
    //   // The columns array will also need to be re-sorted so that the column selected becomes the
    //   // second column in the array. The VarietyName column is always the first column
    //   // The state is updated with the sorted cells
    //   // Update the display index of the columns first to column index * 10,
    //   // then set the variety name column display index to 0 and the selected column to 5
    //   // then sort the columns by display index and add to state.
    useEffect(() => {
        const sortColumns = () => {
            const updatedColumns = columns.map((column, index) => {
                if (!column.sortedDisplayIndex) {
                    column.sortedDisplayIndex = 0;
                }
                column.sortedDisplayIndex = column.originalDisplayIndex * 10;
                return column;
            });
            try {
                if (!updatedColumns)
                    return;
                const varietyNameColumn = updatedColumns.find((column) => column.columnName === "varietyName");
                if (varietyNameColumn) {
                    varietyNameColumn.sortedDisplayIndex = 0;
                }
                //updatedColumns.find((column) => column.ColumnID === sortConfig.selectedColumnID)!.SortedDisplayIndex = 5;
                const selectedColumn = updatedColumns.find((column) => column.columnId === sortConfig.selectedColumnID);
                if (selectedColumn) {
                    selectedColumn.sortedDisplayIndex = 5;
                }
                updatedColumns.sort((a, b) => a.sortedDisplayIndex - b.sortedDisplayIndex);
            }
            catch (error) {
                console.log("error", error);
            }
            // console.log({ updatedColumns });
            setSortedColumns(updatedColumns);
        };
        sortColumns();
    }, [columns, sortConfig]);
    return (React.createElement(TableHead, { key: "trh001" },
        React.createElement(TableRow, { key: "tr001", sx: { backgroundColor: "#ffffff", color: "#111111" } }, sortedColumns.map((column, index) => {
            var _a;
            return (React.createElement(TableCell, { key: `${column.columnName}-${index}-cellr001`, sx: {
                    cursor: "pointer",
                    backgroundColor: "transparent",
                    border: "solid 1px #f1f1f1",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1.0em",
                    padding: "0.5em",
                    color: "#111111",
                    width: index === 0 ? "200px !important" : "150px !important",
                }, rowSpan: index === 0 ? 2 : 1, onClick: () => handleColumnClick(index, column.columnId), "data-column": column.columnName },
                column.displayName,
                React.createElement(Grid, { container: true, key: `${column.columnName}-${index}-container001` },
                    React.createElement(Grid, { key: `${column.columnName}-${index}-avg001`, item: true, xs: index === 1 ? 6 : 12, sx: { fontWeight: "normal", fontSize: "0.7em" } }, (_a = column.dataResultUnit) !== null && _a !== void 0 ? _a : "AVG (kg/ha)"),
                    index === 1 ? (React.createElement(Grid, { key: `${column.columnName}-${index}-lsd001`, item: true, xs: 6, sx: { fontWeight: "normal", fontSize: "0.7em" } }, "Sig (5%)")) : null)));
        }))));
};
export default TrialTableHeaderRow;
